import React, { PureComponent } from 'react';
import { Image, CarouselItem, Carousel } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

//IMAGES
import ErrorIcon from "../images/svgs/Error.svg";
class Product extends PureComponent {
  state = {
    activeIndex: 0
  }
  redirectToDetail = (product) => {
    // console.log('props', this.props);
    this.props.history.push({
      pathname: `/clientwebsite2/productDetail/${product.instagram_pid}`,
      // Change later to /productDetail
      state: {
        media: product.media,
        whatsappLink: this.props.whatsappLink,
        businessName: this.props.businessName,
      },
    });
  };
  handleSelect = (index) => {
    this.setState({
      activeIndex: index
    })
  }
  render() {
    const {
      selected,
      dashboard,
      featuredProductsList
      //  currency 
    } = this.props;
    // const price = this.props.media.prices && this.props.media.prices.length > 0 && this.props.media.prices.find(pr => pr.currency === currency)
    return (
      <Carousel interval={5000} activeIndex={this.state.activeIndex} onSelect={this.handleSelect} className={"featuredCarousel"}>
        {featuredProductsList.map(product => (
          <CarouselItem
            onClick={() => {
              if (dashboard) {
                this.props.addToCart(product)
              } else
                this.redirectToDetail(product)
            }}
            // className="featuredProductDetailContainer"
            className={"featuredCarouselItem"}
            style={{
              width: window.innerWidth <= 991 ? window.innerWidth : "60vw",
              height: window.innerWidth <= 991 ? 270 : 440,

            }}
            key={product.imageId}

          >
            {selected ?
              <Image
                className="notSelected"
                src={ErrorIcon}
              />
              : <div className="emptyDiv"></div>
            }
            <div className={`imageDiv ${selected ? "selectedImage" : ""}`}>
              <Image style={{ width: "100%", height: "100%", objectFit: "cover" }} src={product.media && product.media.length > 0 && product.media[0].url} alt={product.name} />
            </div>
            {/* <div className="prodInfo">
          <h4 className="productName">
            {this.props.media.name ? this.props.media.name : ''}
          </h4>

          <h3 className={"productPrice"}>
            {price ? (
              <div>
                <span>{price.currency}</span>
                {price.price}
              </div>
            ) : (
                ''
              )}
          </h3>
        </div> */}
          </CarouselItem>
        ))}
      </Carousel>
    );
  }
}

export default withRouter(Product);



// WEBPACK FOOTER //
// ./src/components/FeaturedProduct.js